module.exports = __webpack_public_path__ + "img/awards10.1bfea963.svg";